import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20background%2C%20colorful%20comic%20panels%20arrangement%2C%20warm%20artistic%20illustration%2C%20soft%20gradient%20with%20coral%20and%20mint%20tones%2C%20abstract%20geometric%20shapes%2C%20clean%20modern%20composition%2C%20subtle%20texture%2C%20editorial%20quality%2C%20no%20text%2C%20atmospheric%20lighting&width=1800&height=900&seq=hanman-hero-bg&orientation=landscape"
          alt="韩漫漫画网站背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <p className="text-white/70 text-xs md:text-sm font-medium tracking-widest uppercase mb-4">
          发现精彩韩漫世界
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white text-center leading-tight mb-4">
          发现精彩
          <br />
          <span className="italic">韩漫世界</span>
        </h1>
        <p className="text-white/60 text-sm md:text-base max-w-lg text-center mb-8">
          汇集全网最全韩国漫画，高清下拉式阅读，无广告纯享体验
        </p>
        <Link
          to="/category"
          className="inline-flex items-center px-8 py-3 rounded-full bg-white/20 backdrop-blur-sm text-white text-sm font-medium hover:bg-white/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          探索漫画大全
          <i className="ri-arrow-right-line ml-2"></i>
        </Link>
      </div>
    </section>
  );
}